/**
 * Product KPI Metrics API
 *
 * 服务于 admin "产品 KPI" 看板（U6）。
 * 后端契约：acquilang-backend/app/api/v1/metrics.py
 */
import { request } from '@/api/client'
import { API_ENDPOINTS as apiEndpoints } from '@/api/endpoints'

/** 单个快照点。 */
export interface DashboardPoint {
  snapshot_date: string // YYYY-MM-DD
  value: number | null // null = 当日无样本（如 i+1 当日无生成 / cohort 空）
  dimensions: Record<string, unknown>
}

/** 折线序列响应。 */
export interface DashboardSeriesResponse {
  metric_name: string
  definition: string
  range: string // '30d' | '90d'
  series: DashboardPoint[]
}

/** 所有受支持指标 + 定义。 */
export type DashboardListResponse = Record<string, { definition: string }>

export type MetricRange = '30d' | '90d'

export const metricsApi = {
  /** 列出所有受支持指标 + 中文定义。 */
  listDashboard() {
    return request.get<DashboardListResponse>(apiEndpoints.METRICS.DASHBOARD_LIST)
  },

  /** 获取单个指标最近 N 天的快照序列。 */
  getSeries(metricName: string, range: MetricRange = '30d') {
    return request.get<DashboardSeriesResponse>(
      apiEndpoints.METRICS.DASHBOARD_SERIES(metricName),
      { params: { range } },
    )
  },
}
